import { render, staticRenderFns } from "./GroupMemberNav.vue?vue&type=template&id=954b134c&"
import script from "./GroupMemberNav.vue?vue&type=script&lang=ts&"
export * from "./GroupMemberNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports